import React from 'react';
import AdvanceInvoice from 'components/Tvendo/Distribution/Queries/AdvanceInvoice/AdvanceInvoice';
export default function () {
  return <AdvanceInvoice />;
}
